<template>
  <v-container fluid class="grey800 px-8 py-6">
    <h5 class="text-h6 text-uppercase font-weight-bold green500--text">
      Get free scrap
    </h5>
    <p class="text-body-2 green100--text">
      bandit.camp gives back to the community in <b>many</b> ways, check it out below.
    </p>

    <v-row dense>
      <v-col v-if="!promo.levelRewards.disabled" cols="12" class="mb-2">
        <v-card
          flat tile :ripple="false"
          class="promo-item grey500"
          @click="$modal.open('account', { maxWidth: 1000 }); close()"
        >
          <div class="d-flex align-center">
            <div class="icon green800 py-1 px-1">
              <!-- <fai :icon="['fad', 'coins']" fixed-width class="text-body-1 black--text" /> -->
              <v-img src="@/assets/img/levels/tiers/10-large.png" contain width="36" />
            </div>
            <div class="text-body-2 py-2 px-3 font-weight-semibold">
              NEW: Level rewards
            </div>
          </div>
        </v-card>
      </v-col>

      <v-col v-if="!promo.dailyCase.disabled" cols="12">
        <v-card
          flat tile
          :ripple="false"
          class="promo-item grey500 "
          @click="$modal.open('daily-case', { maxWidth: 800 }); close()"
        >
          <div class="d-flex align-center">
            <div class="icon primary600 py-2 px-3">
              <fai :icon="['fad', 'box-full']" fixed-width class="text-body-1 primary100--text" />
            </div>
            <div class="text-body-2 py-2 px-3 font-weight-semibold">
              Open your daily case
            </div>
          </div>
        </v-card>
      </v-col>

      <v-col v-if="!promo.faucet.disabled" cols="12">
        <v-card
          flat tile
          :ripple="false"
          class="promo-item grey500"
          @click="$modal.open('faucet', { maxWidth: 400 }); close()"
        >
          <div class="d-flex align-center">
            <div class="icon green700 py-2 px-3">
              <fai :icon="['fad', 'coins']" fixed-width class="text-body-1 green100--text" />
            </div>
            <div class="text-body-2 py-2 px-3 font-weight-semibold">
              Claim <scrap :amount="promo.faucet.amount" /> every {{ promo.faucet.cooldown / 60 / 1000 }} minutes
            </div>
          </div>
        </v-card>
      </v-col>

      <v-col v-if="promo.giveaway.url" cols="12">
        <v-card
          flat tile
          :ripple="false"
          class="promo-item grey500"
          :to="{name: 'Giveaway'}"
          @click="close()"
        >
          <div class="d-flex align-center">
            <div class="icon yellow darken-3 py-2 px-3">
              <fai :icon="['fad', 'crown']" fixed-width class="text-body-1 white--text" />
            </div>
            <div class="text-body-2 py-2 px-3 font-weight-semibold">
              Join our epic giveaway
            </div>
          </div>
        </v-card>
      </v-col>

      <v-col v-if="!promo.giftcodes.disabled" cols="12">
        <v-card
          flat tile
          :ripple="false"
          class="promo-item grey500"
          @click="$modal.open('giftcodes', { maxWidth: 400 }); close()"
        >
          <div class="d-flex align-center">
            <div class="icon blue600 darken-3 py-2 px-3">
              <fai :icon="['fad', 'gift-card']" fixed-width class="text-body-1 blue100--text" />
            </div>
            <div class="text-body-2 py-2 px-3 font-weight-semibold">
              Redeem a promo code
            </div>
          </div>
        </v-card>
      </v-col>

      <v-col v-if="!conga.affiliates.disabled" cols="12">
        <v-card
          flat tile
          :ripple="false"
          class="promo-item grey500"
          @click="$modal.open('refcode', {maxWidth: 400}); close()"
        >
          <div class="d-flex align-center">
            <div class="icon blue600 darken-3 py-2 px-3">
              <fai :icon="['fad', 'users']" fixed-width class="text-body-1 blue100--text" />
            </div>
            <div class="text-body-2 py-2 px-3 font-weight-semibold">
              Redeem an affiliate code
            </div>
          </div>
        </v-card>
      </v-col>

      <v-col v-if="!conga.deposits.offerwalls.disabled" cols="12">
        <v-card
          flat tile
          :ripple="false"
          class="promo-item grey500"
          :to="{name: 'Offers'}"
          @click="close()"
        >
          <div class="d-flex align-center">
            <div class="icon grey300 darken-3 py-2 px-3">
              <fai :icon="['fad', 'poll-people']" fixed-width class="text-body-1 grey100--text" />
            </div>
            <div class="text-body-2 py-2 px-3 font-weight-semibold">
              Complete offers and surveys
            </div>
          </div>
        </v-card>
      </v-col>

      <v-col cols="12">
        <v-card
          flat tile
          :ripple="false"
          class="promo-item grey500"
          href="https://discord.gg/banditcamp"
          target="_blank"
          rel="noopener noreferrer"
        >
          <div class="d-flex align-center">
            <div class="icon grey300 darken-3 py-2 px-3">
              <fai :icon="['fab', 'discord']" fixed-width class="text-body-1 grey100--text" />
            </div>
            <div class="text-body-2 py-2 px-3 font-weight-semibold">
              Daily giveaways &amp; codes on Discord
            </div>
          </div>
        </v-card>
      </v-col>

      <v-col cols="12">
        <v-card
          flat tile
          :ripple="false"
          class="promo-item grey500"
          href="https://twitter.com/banditcamprust"
          target="_blank"
          rel="noopener noreferrer"
        >
          <div class="d-flex align-center">
            <div class="icon grey300 darken-3 py-2 px-3">
              <fai :icon="['fab', 'twitter']" fixed-width class="text-body-1 grey100--text" />
            </div>
            <div class="text-body-2 py-2 px-3 font-weight-semibold">
              Promo codes on our Twitter
            </div>
          </div>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  props: {
    close: {
      type: Function,
      required: true,
    },
  },
  computed: {
    ...mapGetters({
      conga: 'conga/conga',
    }),
    promo() {
      return this.conga.promo
    },
  },
}

</script>

<style lang="scss" scoped>
.promo-item {
  .icon {

  }
}
</style>
